import React, { createContext, useState, useContext } from "react";

const SearchContext = createContext();

export const useSearch = () => useContext(SearchContext);

export const SearchProvider = ({ children }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredPage, setFilteredPage] = useState(0);
  const [filteredRowsPerPage, setFilteredRowsPerPage] = useState(10);

  return (
    <SearchContext.Provider
      value={{
        searchTerm,
        setSearchTerm,
        filteredPage,
        setFilteredPage,
        filteredRowsPerPage,
        setFilteredRowsPerPage,
      }}
    >
      {children}
    </SearchContext.Provider>
  );
};
